import request from '../../utils/request';

const getContract = (contractId) =>
  request({
    url: `/enrollment/contract/${contractId}`,
    method: 'GET',
    responseType: 'blob',
  });

const getArt150 = (enrollmentId) =>
  request({
    url: `/enrollment/${enrollmentId}/conyugalDeclaration`,
    method: 'GET',
    responseType: 'blob',
  });
const getUAF = (enrollmentId) =>
  request({
    url: `/enrollment/${enrollmentId}/uafform`,
    method: 'GET',
    responseType: 'blob',
  });

export default { getContract, getArt150, getUAF };
